export function getBelgianSideCode(license_plate: string) {
    const sideCode = belgianSidecodes.findIndex((sidecode: RegExp) => license_plate.match(sidecode));

    return sideCode !== -1 ? sideCode : null;
}

export const belgianSidecodes: RegExp[] = [
    /^([a-zA-Z]{1})([0-9]{3})([a-zA-Z]{1})$/, //X-999-X
    /^([0-9]{1})([0-9]{3})([a-zA-Z]{1})$/, //9-999-X
    /^([a-zA-Z]{3})([0-9]{3})$/, //XXX-999
    /^([0-9]{3})([a-zA-Z]{3})$/, //999-XXX
    /^([0-9]{1})([a-zA-Z]{3})([0-9]{3})$/, //9-XXX-999
    /^([0-9]{1})([0-9]{3})([a-zA-Z]{3})$/, //9-999-XXX
];
